import React, { useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import ConfirmModal from "../../Components/ConfirmModal/ConfirmModal";
import ContentHeader from "../../Components/ContentHeader/ContentHeader";
import Loading from "../../Components/Loading/Loading";
import Table from "../../Components/Table/Table";
import Search from "../../Components/Search/Search";
import RrbDropdown from "../../Components/RRBDropdown/RrbDropdown";
import SupportTicketView from "../../Components/SupporTicketView/SupportTicketView";
import FormModal from "../../Components/FormModal/FormModal";
import { Formik } from "formik";
import * as Yup from "yup";
import CenFilters from "../../Components/CenFilters/CenFilters";
import CustomToast from "../../Components/CustomToast/CustomToast";

const validationSchema = Yup.object().shape({
      reason: Yup.string()
      .required("Reason is required"),
  });
function SupportTicketUi({
  columns,
  data,
  loading,
  deleteAdminFn,
  onPageChange,
  tableQaury,
  totalRecords,
  setTableQaury,
  selectData,
  setFiltersId,
  setSelectData,
  filtersId,
  refetchStates,
  refetchcity,
  applyFilter,
  removeFilter,
  decodedToken,
  supportTicketView,
  handleCloseViewModal,
  supportTicketViewData,
  handleCloseModal,
  showForm,
  updateData,
  handleSubmit,
  toast
}) {
  const totalPages = Math.ceil(totalRecords / tableQaury?.rowsPerPage);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <ContentHeader
              title={"Support Ticket"}
              buttonName={""}
              buttonBoolean={false}
              pageName={"Support Ticket"}
              linkPath={""}
            />

            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
              {/* {( decodedToken?.role == 3 || decodedToken?.role == 4) && (
                  <div>
                    <CenFilters
                      selectData={selectData}
                      setFiltersId={setFiltersId}
                      refetchStates={refetchStates}
                      refetchcity={refetchcity}
                      setSelectData={setSelectData}
                      filtersId={filtersId}
                      applyFilter={applyFilter}
                      removeFilter={removeFilter}
                      decodedToken={decodedToken}
                      showFilter={{
                        rrb: true,
                        state: false,
                        city: false,
                        center: false,
                        button: true
                      }}
                    />
                  </div>
                )} */}
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                      {toast && (
                          <CustomToast
                            text={toast?.message}
                            type={toast?.type}
                          />
                        )}
                        {/* <Search
                          setTableQaury={setTableQaury}
                          tableQaury={tableQaury}
                          placeHolder={"Search By Here"}
                        /> */}



                          <div className="d-flex mb-3">
                            <div className={`d-md-flex ${(decodedToken?.role == 3 || decodedToken?.role == 4) ? "mr-3" : "mr-0"} justify-content-between align-items-center dt-layout-start `}>
                              {(decodedToken?.role == 3 || decodedToken?.role == 4) ? (
                                <>
                                  <RrbDropdown
                                    selectData={selectData}
                                    setFiltersId={setFiltersId}
                                    setSelectData={setSelectData}
                                    filtersId={filtersId}
                                    removeFilter={removeFilter}
                                    decodedToken={decodedToken}
                                    showFilter={{
                                      rrb: true,
                                    }}
                                  />
                                </>
                              ) : (
                                null
                              )}
                            </div>

                            <Search
                              setTableQaury={setTableQaury}
                              tableQaury={tableQaury}
                              placeHolder={"Search By Here"}
                              buttonName={""}
                              buttonBoolean={false}
                              linkPath={""}
                            />

                          </div>

                        <Table
                          columns={columns}
                          data={data}
                          // loading={isLoading}
                          pagination={totalPages}
                          onPageChange={onPageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
      {showForm && (
        <Formik
          initialValues={{
            reason:  "",
          }}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values, { resetForm }) => handleSubmit(values, resetForm)}
        >
          {(formik) => (
            <FormModal formik={formik} handleCloseModal={handleCloseModal} title="Add Comments">
              <div className="form-group">
                <label htmlFor="reason">Comments</label>
                <textarea
                  type="text"
                  name="reason"
                  className={`form-control ${
                    formik.errors.reason && formik.touched.reason
                      ? "is-invalid"
                      : ""
                  }`}
                  id="reason"
                  placeholder="Enter Comments"
                  {...formik.getFieldProps("reason")}
                  rows="3"
                ></textarea>
                {formik.errors.reason && formik.touched.reason && (
                  <span className="invalid-feedback">
                    {formik.errors.reason}
                  </span>
                )}
              </div>
            </FormModal>
          )}
        </Formik>
      )}
      {supportTicketView ? (
        <SupportTicketView
          handleCloseModal={handleCloseViewModal}
          data={supportTicketViewData}
        />
      ) : null}
      <ConfirmModal
        confirmFn={deleteAdminFn}
        text={"Are you sure, you want to Delete?"}
        buttonText={"Delete"}
      />
    </div>
  );
}

export default SupportTicketUi;
